import compose from 'lodash/fp/compose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import changeRequestInProgress from '../generic/request-in-progress/actions';
import compareTotalBudgetsQuote from '../utils/compare-total-budgets-quote';
import {
  applyFilters,
  submit,
  toggleCommercialIncentiveModal,
} from './actions';
import QuoteEditor from './QuoteEditor';
import { calculateInvoiceSums } from './utils/calculate-derived-values';

const mapStateToProps = state => {
  const { quote, quoteLinesById } = state.quoteEditor;
  const { isRequestInProgress } = state;
  return {
    model: quote,
    invoiceSums: calculateInvoiceSums({
      quote,
      quoteLinesById,
    }),
    isRequestInProgress,
    quoteLinesById,
  };
};

const mapDispatchToProps = {
  submit,
  applyFilters,
  toggleCommercialIncentiveModal,
  changeRequestInProgress,
};

const mergeProps = (
  { invoiceSums, model, isRequestInProgress, quoteLinesById },
  dispatchProps,
  ownProps,
) => ({
  model,
  isRequestInProgress,
  ...ownProps,
  onSubmit: async event => {
    event.preventDefault();
    if (model.salesforceId) {
      compareTotalBudgetsQuote(ownProps.initialQuote, model, quoteLinesById);
    }
    await dispatchProps.changeRequestInProgress(true);
    const { freeServiceValue } = invoiceSums;
    if (freeServiceValue && !model.commercialIncentive) {
      dispatchProps.toggleCommercialIncentiveModal(true);
      await dispatchProps.changeRequestInProgress(false);
      return;
    }
    await dispatchProps.submit(ownProps.initialQuote);
    await dispatchProps.applyFilters();
  },
  toggleCommercialIncentiveModal: toggle =>
    dispatchProps.toggleCommercialIncentiveModal(toggle),
});

// Provide the location as prop, in order to bust the should component render cache
export default compose([
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
])(QuoteEditor);
